
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 3c-1.254 0-2.39.574-3.219 1.438-.828.863-1.39 1.98-1.75 3.28l-3.719 13.25.094.032C4.18 21.629 4 22.297 4 23c0 1.555.426 3.05 1.438 4.188C6.449 28.323 8.015 29 10 29a6.53 6.53 0 002.781-.656C13.867 27.812 15 26.672 15 25v-.063s-.035-1.011-.719-2C13.598 21.95 12.184 21 10 21c-.512 0-.902.188-1.281.5A1.966 1.966 0 008 23c0 .469.168.918.5 1.313.332.394.883.687 1.5.687v-1.969c-.031.028 0-.02 0-.031 1.664 0 2.27.55 2.625 1.063.344.5.375.945.375.968v.032c-.023.816-.438 1.18-1.094 1.5-.676.332-1.594.437-1.906.437-1.566 0-2.492-.45-3.094-1.125C6.305 25.199 6 24.207 6 23c0-2.219 1.781-4 4-4 3.383 0 5.227 1.973 7.219 4.594h-.032S20.23 28 25 28h.875l.125-.875 1.875-15L28 11h-1.125c-3.867 0-6.125-2.656-6.125-2.656-.95-1.262-1.66-2.551-2.781-3.594C16.832 3.691 15.239 3 13 3zm0 2c1.86 0 2.762.445 3.594 1.219.832.773 1.566 1.98 2.625 3.375v.031l.031.031s2.445 2.668 6.5 3.156l-1.625 13c-3.027-.53-5.313-3.406-5.313-3.406h-.03C16.71 19.68 14.202 17 10 17c-.977 0-1.871.3-2.688.719L9.97 8.28c.293-1.058.758-1.922 1.281-2.469C11.773 5.266 12.313 5 13 5z"}})])
          )
        }
      }
    